import { mergeQueryKeys } from '@lukemorales/query-key-factory';

import { auth } from '@common/api/auth/queryKeys';
import { plaid } from '@common/api/plaid/queryKeys';
import { servicesProviders } from '@common/api/services-providers/queryKeys';
import { aiBdc } from '@features/ai-bdc/api/queryKeys';
import { conversations } from '@features/conversations/api/queryKeys';
import { discounts } from '@features/discounts/api/queryKeys';
import { inventory } from '@features/inventory/api/queryKeys';
import { leads } from '@features/leads/api/queryKeys';
import { orders } from '@features/orders/api/queryKeys';
import { credits, planDetails } from '@features/plan_and_usage/api/queryKeys';
import { preorders } from '@features/preorders/api/queryKeys';
import { team } from '@features/team/api/queryKeys';

export const queries = mergeQueryKeys(
	auth,
	servicesProviders,
	aiBdc,
	conversations,
	inventory,
	leads,
	orders,
	preorders,
	plaid,
	planDetails,
	credits,
	discounts,
	team,
);
